import { required, maxLength, minLength, numeric, integer, minValue, maxValue, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      starting_cash: {
        required: helpers.withMessage(i18n.global.t('Please enter a starting cash.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the starting cash.'), numeric)
      },
      started_at: {
        required: helpers.withMessage(i18n.global.t('Please enter a started at.'), required),
      },
      session_no_start: {
        integer: helpers.withMessage(i18n.global.t('Please enter a valid integer for the session number.'), integer),
        minValue: helpers.withMessage(i18n.global.t('The session number must be at least 1.'), minValue(1)),
      }
    }
  }
};
